import type { ProfileDto } from '@bldsoft/cappie/api/wbs'
import type { IProfile } from '@setplex/tria-api'
import type { ApiType } from '../../../shared/schemas'
import type { KidsProfileTypeDto, ProfileSummaryDto } from './profiles.h'

import { AvatarName, MAX_NUMBER_OF_PROFILES } from '@setplex/tria-api'
import * as v from 'valibot'

export const ProfileSchema = v.object({
  id: v.number(),
  name: v.nullish(v.string()),
  kidsProfile: v.nullish(v.boolean(), false),
  avatarName: v.nullish(
    v.picklist([
      AvatarName.FOX,
      AvatarName.RACOON,
      AvatarName.HAMSTER,
      AvatarName.MOOSE,
      AvatarName.ZEBRA,
      AvatarName.RABBIT,
    ]),
    null
  ),
  kidsProfileTypeId: v.nullish(v.number(), null),
  locked: v.nullish(v.boolean(), false),
  avatar: v.nullish(v.string(), null),
}) satisfies ApiType<ProfileDto, IProfile>

export const KidsProfileTypeSchema = v.object({
  id: v.number(),
  title: v.nullish(v.string()),
}) satisfies ApiType<KidsProfileTypeDto, any>

export const ProfileSummarySchema = v.object({
  profiles: v.array(ProfileSchema),
  meta: v.object({
    kidsModuleAvailable: v.nullish(v.boolean(), false),
    remainingRegularProfiles: v.nullish(v.number(), 0),
    remainingKidsProfiles: v.nullish(v.number(), 0),
    kidsProfileTypes: v.nullish(v.array(KidsProfileTypeSchema), []),
  }),
}) satisfies ApiType<ProfileSummaryDto, any>

export const ProfilesListSchema = v.pipe(
  v.array(ProfileSchema),
  v.transform((profiles) => ({
    profiles,
    meta: {
      kidsModuleAvailable: false,
      remainingRegularProfiles: MAX_NUMBER_OF_PROFILES - profiles.length || 0,
      remainingKidsProfiles: 0,
      kidsProfileTypes: [] as Array<{ id: number; title?: string | null }>,
    },
  }))
)
